import { nanoid } from "nanoid";
import { IPageContent, IRouterState } from "../../contexts/router";
import { ICommonState } from "../../hooks/common-state";
import { IErrorWithMeta } from "../../util/custom-errors";
import { getEnvironmentDetails } from "../../util/platform-details";
import { IErrorLog, sendErrorLog } from "./errors";

export default function sendError(
  error: IErrorWithMeta,
  router: IRouterState,
  commonDetails: ICommonState
) {
  if (!(error instanceof Error)) {
    error = new Error(JSON.stringify(error));
  }
  const errorLog: IErrorLog = getSkeletonErrorObject(commonDetails, router);
  errorLog.message = error.message;
  errorLog.stack_trace = error.stack;
  if (error.meta) {
    const meta = error.meta;
    if (meta.name === "API_ERROR") {
      errorLog.severity = meta.severity;
      errorLog.code = meta.statusCode;
      errorLog.event_name = meta.name;
      errorLog.api_request = JSON.stringify(meta.request);
      errorLog.api_response = JSON.stringify(meta.response);
    } else if (meta.name === "MALFORMED_API_RESPONSE_ERROR") {
      errorLog.severity = meta.severity;
      errorLog.event_name = meta.name;
      errorLog.api_request = JSON.stringify(meta.request);
      errorLog.api_response = JSON.stringify(meta.response);
    } else if (meta.name === "INITILIZATION_ERROR") {
      errorLog.severity = meta.severity;
      errorLog.event_name = meta.name;
    } else if (meta.name === "INTERNAL_ERROR") {
      errorLog.severity = meta.severity;
      errorLog.event_name = meta.name;
      errorLog.function_arguments = JSON.stringify(meta.functionArguments);
      errorLog.function_name = meta.functionName;
    }
  } else {
    errorLog.severity = "EXCEPTION";
    errorLog.event_name = "UNKNOWN_ERROR";
  }
  sendErrorLog(errorLog);
}

const getSkeletonErrorObject = (
  commonDetails: ICommonState,
  routerState: IRouterState
): IErrorLog => {
  const platform = getEnvironmentDetails();
  return {
    type: "SYSTEM",
    severity: null,
    event_name: null,
    event_id: nanoid(),
    event_source: "EUI",
    eui_url: window?.location?.href,
    user_id: commonDetails?.user?.userId,
    client_id: commonDetails?.user?.client,
    timestamp: new Date().toISOString(),
    analytics_version: "4.0.0",
    fe_version: "4.00",
    session_id: commonDetails?.sessionId,
    session_time:
      new Date().valueOf() - commonDetails?.session_start_time?.valueOf(),
    campaign_id: "not_available",
    code: null,
    message: null,
    stack_trace: null,
    platform_details: {
      device_type: platform.deviceType,
      os: platform.os,
      agent_type: platform.agentType,
      app_platform: platform.appPlatform,
    },
    api_request: null,
    api_response: null,
    router_state: JSON.stringify(getContentArray(routerState)),
    error_page: JSON.stringify(commonDetails?.currentPage?.page?.content),
    function_arguments: null,
    function_name: null,
  };
};

const getContentArray = (state: IRouterState) => {
  const contents: IPageContent[] = [];
  if (state && state.allIds.length) {
    for (let i = 0; i < state.allIds.length; i++) {
      const id = state.allIds[i];
      contents.push(state.byId[id].content);
    }
  }
  return contents;
};
